import React from "react";
export const InstrumentInformationsContext = React.createContext({});
